import { withInstall } from '@xzx-design/utils'
import _Tag from './src/tag'

export const Tag = withInstall(_Tag)
export default Tag

export * from './src/tag'
export * from './src/types'
